import { useState, useCallback, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Navbar from './components/Navbar';
import SidebarToggle from './components/SidebarToggle';
import FloatingSidebar from './components/FloatingSidebar';
import Articles from './pages/Articles';
import Experience from './pages/Experience';
import Projects from './pages/Projects';
import FAQ from './pages/FAQ';
import Article from './components/Article';
import { ThemeProvider } from './context/ThemeContext';

function App() {

    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    const handleSidebarOpen = useCallback(() => {
        setIsSidebarVisible(true);
    }, []);

    useEffect(() => {
        document.title = "Ayush Kaushik";
    }, []);

    return (
        <ThemeProvider>
            <BrowserRouter>
                <SidebarToggle onClick={handleSidebarOpen} />
                <FloatingSidebar
                    isVisible={isSidebarVisible}
                    onClose={() => setIsSidebarVisible(false)}
                />

                <header className="site-header">
                    <Navbar />
                </header>

                <main className="pt-20 sm:pt-24">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/experience" element={<Experience />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/blogs" element={<Articles />} />
                        <Route path="/faq" element={<FAQ />} />
                        <Route path="/blog/:postId" element={<Article />} />
                    </Routes>
                </main>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
